import React, { FC, useMemo } from "react";
import { i18n } from "@/locales";

export interface KeywordSTTParams {
  content: string;
  mark?: string;
}

export const KeywordSTT: FC<KeywordSTTParams> = ({ content, mark }) => {
  const language = useMemo(() => i18n.language, []);

  return (
    <>
      <span className={`authing-keyword-${mark ?? content}`}>{content}</span>
      <span className={`authing-keyword-content-${mark ?? content}-${language}`} />
    </>
  );
};
